var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveNowTag = function SvgLiveNowTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.994 8.92H0L2.368.08h2.731L3.315 6.745h4.262zm4.396 0H8.653L11.02.08h2.737zm4.739 0-.97-8.84h2.855l.286 6.361 3.668-6.36h2.772l-5.65 8.838h-2.961m16.619-6.953h-4.582L27.79 3.37h4.25l-.483 1.803h-4.25l-.467 1.742h4.714l-.536 2.002h-7.452L25.934.08h7.319z"
  })));
};
export default SvgLiveNowTag;